// Catatan perubahan Jarvis, terbaru di atas. Tambahkan satu entri setiap rilis
// (bersamaan dengan bump versi di package.json & public/version.json).
//
// type per item: 'baru' (fitur baru), 'ubah' (perubahan perilaku/tampilan),
// 'perbaikan' (bug fix). Tulis dari sudut pandang pengguna, bukan nama file.
export const CHANGELOG = [
  {
    version: '5.27.1',
    date: '2026-10-21',
    title: 'Kartu People Improvement kembali ringkas',
    items: [
      { type: 'ubah', text: 'Kartu People Improvement di KPI Outlet kembali hanya menampilkan Tindakan Terbukti Improve (nilai dan jumlah tindakan yang terbukti improve). Rincian personel dan progress tetap ada di Lihat Detail.' },
    ],
  },
  {
    version: '5.27.0',
    date: '2026-10-21',
    title: 'Dashboard Rekomendasi Ditolak & filter Service Advisor',
    items: [
      { type: 'baru', text: 'Filter Service Advisor di Rekomendasi Ditolak: seluruh dashboard (angka, alasan, tren, item, catatan, daftar) menampilkan data SA terpilih. Klik baris SA di tabel perbandingan juga menyaring.' },
      { type: 'baru', text: 'Perbandingan Service Advisor kini adil: berapa persen order yang ditangani SA punya penolakan, dibanding rata-rata cabang (batang merah = di atas rata-rata). Tabel bisa diurutkan per kolom.' },
      { type: 'ubah', text: 'Tampilan dashboard baru: angka utama dengan perbandingan bulan lalu, ringkasan "Yang perlu diperhatikan", grafik alasan bisa ditukar Jumlah/Nilai, tren 6 bulan dengan sumbu, item tersering dengan bagian yang akhirnya dikerjakan, dan catatan pelanggan terbaru.' },
      { type: 'perbaikan', text: 'Halaman Rekomendasi Ditolak tidak lagi menyisakan area kosong yang bisa di-scroll di bawah konten.' },
    ],
  },
  {
    version: '5.26.0',
    date: '2026-10-21',
    title: 'Kartu People Improvement lebih mudah dibaca & laporan rekomendasi ditolak',
    items: [
      { type: 'baru', text: 'Menu baru Statistik → Rekomendasi Ditolak: rekap per bulan item servis yang ditolak pelanggan (jumlah, nilai, sebaran alasan, tren 6 bulan, per Service Advisor, item tersering), tanda item yang akhirnya dikerjakan di servis berikutnya, dan daftar detail dengan catatan penolakan yang bisa diunduh CSV. Angkanya sama dengan pitscore.' },
      { type: 'ubah', text: 'Kartu People Improvement di KPI Outlet tidak lagi mengulang nilai yang sama. Isinya kini: tindakan terbukti improve (mis. 7 / 16), personel sudah improve (mis. 4 / 8, yaitu personel yang semua tindakannya terbukti improve), pita progress per tahap, serta peringatan Critical belum tuntas dan tindakan lewat deadline.' },
      { type: 'baru', text: 'Bila nilai berbeda dari perbandingan jumlah tindakan, kartu menjelaskan sebabnya: tindakan Critical & Major dihitung lebih berat dari Minor.' },
      { type: 'ubah', text: 'Ringkasan di atas Lihat Detail People Improvement memakai istilah yang sama: Nilai, Personel Sudah Improve, Tindakan Terbukti Improve, dan Tindakan Aktif. Kontribusi KPI pindah ke keterangan kartu Nilai.' },
    ],
  },
  {
    version: '5.25.0',
    date: '2026-10-19',
    title: 'Komplain bulan lalu belum tuntas tetap di atas',
    items: [
      { type: 'baru', text: 'Personel Prioritas: kelompok baru "Komplain bulan lalu belum tuntas" tepat di bawah "Ada komplain valid" dan di atas "SOP gagal". Isinya personel dengan komplain bulan sebelumnya yang perbaikannya belum tuntas (tindakan belum terbukti improve atau RCA belum selesai), diurutkan dari bobot komplain terberat.' },
      { type: 'ubah', text: 'Personel otomatis keluar dari kelompok itu setelah perbaikannya tuntas. Komplain bulan ini tetap terpisah di "Ada komplain valid", jadi komplain lama tidak bercampur dengan komplain baru.' },
    ],
  },
  {
    version: '5.24.0',
    date: '2026-10-17',
    title: 'Komplain dihitung di bulan kejadiannya',
    items: [
      { type: 'ubah', text: 'Kelompok "Ada komplain valid" kini hanya berisi personel dengan komplain yang terjadi di bulan itu. Komplain bulan sebelumnya yang belum tuntas tidak lagi memberi bobot atau menaikkan peringkat; personelnya diurutkan menurut SOP dan diberi tanda "N komplain bulan lalu belum tuntas".' },
      { type: 'baru', text: 'Komplain yang sudah solved tetap tampil di bulan kejadiannya dengan tanda "solved", termasuk yang baru solved di bulan berikutnya.' },
      { type: 'baru', text: 'Rincian personel memisahkan komplain bulan ini (dengan status Solved / Belum solved) dan komplain bulan sebelumnya yang belum solved.' },
    ],
  },
  {
    version: '5.23.0',
    date: '2026-10-16',
    title: 'Sesuai standar berarti benar-benar tuntas',
    items: [
      { type: 'ubah', text: 'Personel Prioritas: kelompok baru "SOP lulus, tindakan belum tuntas" di antara SOP gagal dan Sesuai standar. Isinya personel yang semua pemeriksaan SOP-nya lulus tetapi masih punya tindakan yang dikerjakan, dipantau (Monitoring), atau perlu diulang. "Sesuai standar" kini hanya untuk personel yang SOP-nya lulus dan tidak punya tindakan yang masih berjalan.' },
    ],
  },
  {
    version: '5.22.1',
    date: '2026-10-15',
    title: 'Status SOP sejalan dengan status tindakan',
    items: [
      { type: 'perbaikan', text: 'People Improvement: SOP yang punya tindakan belum terbukti improve (mis. tindakannya dibuka lagi menjadi Perlu diulang) tidak lagi tertulis "Sudah diperbaiki" walaupun tindakan lamanya untuk SOP yang sama sudah improve. SOP itu kini tampil di baris "Dalam perbaikan" dengan statusnya: Perlu diulang, Belum dimulai, Dalam perbaikan, atau Menunggu bukti.' },
    ],
  },
  {
    version: '5.22.0',
    date: '2026-10-14',
    title: 'Personel Prioritas dikelompokkan',
    items: [
      { type: 'baru', text: 'People Improvement: tabel Personel Prioritas punya pilihan Kelompokkan: Prioritas improvement (bawaan: Ada komplain valid → SOP gagal → Sesuai standar → Belum disampling), Progress, Prioritas, Aktivitas, atau Tanpa grup. Tiap judul kelompok menyebut jumlah orang, alasan urutannya, serta tindakan aktif, lewat deadline, dan yang sudah tuntas. Pilihan tersimpan di perangkat Anda.' },
      { type: 'ubah', text: 'Di dalam kelompok yang nilainya sama, personel dengan tindakan belum selesai di atas: P0 dulu, lalu deadline terdekat. Peringkat (#) tetap urutan pembinaan walau tabel dikelompokkan atau diurutkan lain.' },
      { type: 'ubah', text: 'Tidak ada lagi sel "-": personel tanpa tindakan aktif menampilkan "Semua tindakan tuntas · N terbukti improve" atau "Tindakan belum dibuat" beserta langkah berikutnya; yang kosong disebut jelas (PIC belum ditunjuk, Prioritas/Deadline/Aktivitas belum diisi), deadline yang belum lewat menampilkan sisa harinya.' },
    ],
  },
  {
    version: '5.21.0',
    date: '2026-10-14',
    title: 'Riwayat SOP yang sudah diperbaiki',
    items: [
      { type: 'baru', text: 'People Improvement: setelah tindakan terbukti improve, kolom SOP Gagal menampilkan baris hijau "Sudah diperbaiki" berisi SOP yang dulu gagal beserta bulan asalnya, jadi riwayatnya tetap terlihat tanpa membuka detail. SOP yang sekarang gagal lagi tetap tampil sebagai gagal.' },
      { type: 'baru', text: 'Ekspor CSV People Improvement punya kolom "SOP sudah diperbaiki".' },
    ],
  },
  {
    version: '5.20.0',
    date: '2026-10-13',
    title: 'Per tindakan: aktivitas → tindakan → personel',
    items: [
      { type: 'ubah', text: 'Tab Per tindakan di People Improvement kini bertingkat tiga: aktivitas (Coaching, Training, dst.), lalu tiap tindakannya (rencana, prioritas, deadline, PIC, progres), lalu personel di tindakan itu beserta alasan masuknya.' },
      { type: 'ubah', text: 'Satu set istilah progress di People Improvement, sama dengan Lime: Belum dimulai, Sedang dikerjakan, Monitoring, Selesai (dan Perlu diulang bila gagal di sampling berikutnya). Alur Progress di atas tabel ikut memakai istilah ini, menggantikan Action Plan / Verification Sampling / Gap Closed.' },
      { type: 'baru', text: 'KPI Outlet Baru (beta): Lihat Detail People Improvement mengikuti tampilan yang sama, dengan tab Per personel dan Per tindakan (aktivitas → kasus → personel), pilihan Urutkan, dan Lihat Detail per personel yang menampilkan semua kasusnya.' },
    ],
  },
  {
    version: '5.19.0',
    date: '2026-10-13',
    title: 'People Improvement: per tindakan, urutan improvement, dan perbaikan detail',
    items: [
      { type: 'perbaikan', text: 'Lihat Detail personel yang sudah disampling bulan ini (termasuk yang sudah improve) tidak lagi kosong/error. Penyebabnya catatan auditor per checklist yang salah tempat sehingga seluruh detail gagal tampil.' },
      { type: 'baru', text: 'Kolom Perubahan: naik/turun tingkat keberhasilan SOP dibanding bulan lalu (mis. ▲ +25 poin, September 50% → 75%), supaya terlihat siapa yang improvement-nya paling bagus.' },
      { type: 'baru', text: 'Pilihan Urutkan: improvement terbaik, paling menurun, keberhasilan SOP, progress, aktivitas, prioritas, atau deadline. Judul kolomnya juga bisa diklik. Nomor peringkat tetap menunjukkan urutan prioritas asli.' },
      { type: 'baru', text: 'Tab Per tindakan: kebalikan tabel personel. Pilih aktivitas (Coaching, Training, Briefing, dst.) untuk melihat siapa saja pesertanya, alasan masuknya (SOP & checklist yang gagal, temuan RCA, atau komplain), prioritas, deadline, dan progresnya. Aktivitas paling mendesak di atas.' },
      { type: 'ubah', text: 'Detail personel menampilkan semua tindakannya, termasuk yang sudah terbukti improve, bukan hanya satu tindakan prioritas. Kolom Progress dipindah ke dekat nama supaya terlihat tanpa menggeser tabel.' },
      { type: 'ubah', text: 'Export Data ikut memuat kolom Perubahan dan daftar per tindakan.' },
    ],
  },
  {
    version: '5.18.0',
    date: '2026-10-11',
    title: 'KPI Outlet Baru (beta) sebagai pembanding',
    items: [
      { type: 'baru', text: 'Menu KPI Outlet Baru (beta) di bawah KPI Outlet V4. Tampilannya sama dengan KPI Outlet; bedanya People Improvement dihitung dengan Journey V4 (kasus 60 hari terakhir), dan ada satu baris pembanding: skor versi lama → versi baru beserta selisihnya.' },
      { type: 'baru', text: 'Lihat Detail People Improvement di menu baru lebih ringkas: skor baru vs lama, langkah berikutnya, posisi kasus di 4 status, dan personel prioritas lengkap dengan peringkatnya di versi lama.' },
      { type: 'baru', text: 'Daftar tindakan di menu baru: apa tindakannya, siapa PIC-nya, dan kapan batas waktunya. Tiga teratas tampil di kartu People Improvement, selengkapnya di Lihat Detail; yang terlambat ada di atas.' },
      { type: 'ubah', text: 'Menu KPI Outlet dan KPI Outlet V4 tidak berubah dan tetap menjadi angka resmi. Versi baru belum dipakai untuk penilaian.' },
    ],
  },
  {
    version: '5.17.1',
    date: '2026-10-09',
    title: 'Detail personel sesuai temuannya',
    items: [
      { type: 'perbaikan', text: 'Detail personel di People Improvement kini menampilkan temuan milik personel itu sendiri (dari RCA Business Insight/komplain) dan tahap terkaitnya saja, bukan temuan & semua tahap dari seluruh kasus.' },
      { type: 'perbaikan', text: 'Rencana tindakan tampil lengkap (semua poin), tidak hanya baris pertama.' },
      { type: 'perbaikan', text: 'Peran personel mengikuti data mekanik/SA/jabatannya; personel CS tidak lagi tertulis Mekanik.' },
    ],
  },
  {
    version: '5.17.0',
    date: '2026-10-05',
    title: 'Aktivitas & urutan di People Improvement',
    items: [
      { type: 'baru', text: 'Tabel Personel Prioritas Improvement punya kolom Aktivitas: aktivitas tindakan aktif tiap personel (Training, Coaching, Briefing/reminder, dst.). Ikut di Export Data.' },
      { type: 'baru', text: 'Tabel bisa diurutkan lewat judul kolom Aktivitas atau Prioritas (klik lagi untuk membalik arah); nomor peringkat tetap menunjukkan urutan prioritas asli. Kembali ke urutan bawaan dengan satu klik.' },
    ],
  },
  {
    version: '5.16.1',
    date: '2026-10-03',
    title: 'Bobot komplain terbawa ke bulan berikutnya',
    items: [
      { type: 'ubah', text: 'Komplain bulan lalu yang perbaikannya belum tuntas (tindakan belum selesai, RCA belum Selesai, atau RCA belum ditulis) kini ikut terbawa ke bulan berikutnya dengan bobot penuh, jadi personelnya tetap di urutan atas. Badge komplain menandai berapa yang lanjutan.' },
      { type: 'ubah', text: 'Personel dari RCA komplain tetap masuk daftar prioritas walau RCA-nya belum dibuatkan tindakan (progress: Belum ada tindakan).' },
    ],
  },
  {
    version: '5.16.0',
    date: '2026-10-02',
    title: 'Prioritas & deadline di People Improvement',
    items: [
      { type: 'baru', text: 'Tabel Personel Prioritas Improvement menampilkan Prioritas (P0–P3, tertinggi dari tindakan aktifnya) dan Deadline terdekat; yang lewat ditandai merah, yang belum diisi ditandai. Ikut di Export Data.' },
    ],
  },
  {
    version: '5.15.0',
    date: '2026-10-02',
    title: 'Keberhasilan bulan lalu di People Improvement',
    items: [
      { type: 'baru', text: 'Bila bulan ini belum disampling, tingkat keberhasilan SOP bulan lalu ditampilkan dan dipakai untuk peringkat; bila sudah, ditampilkan sebagai pembanding (▲/▼).' },
      { type: 'ubah', text: 'Urutan tabel mengikuti server, sama persis dengan tab Per Personel di Lime. Angka × SOP lanjutan dihitung per kali SOP gagal, sama dengan bulan lalu.' },
      { type: 'baru', text: 'Detail personel menampilkan catatan auditor di tiap checklist yang tidak sesuai.' },
    ],
  },
  {
    version: '5.14.0',
    date: '2026-10-01',
    title: 'Satu kolom Progress di People Improvement',
    items: [
      { type: 'ubah', text: 'Kolom Progress dan Next Action digabung: Belum dimulai, Sedang dikerjakan, Menunggu sampling, Sudah improve (atau Belum improve, ulangi), dengan langkah berikutnya atau rincian bila tindakannya di beberapa tahap.' },
      { type: 'ubah', text: 'Detail personel menampilkan penyebab utama (bisa lebih dari satu) sesuai pilihan baru di halaman Tindakan.' },
    ],
  },
  {
    version: '5.13.1',
    date: '2026-10-01',
    title: 'SOP gagal tindakan lanjutan tetap terlihat',
    items: [
      { type: 'perbaikan', text: 'Personel dengan tindakan lanjutan dari bulan lalu kini menampilkan SOP gagal asal tindakan itu ("Lanjutan dari September"), walaupun bulan ini belum disampling. Detail personel dan export memuat daftar yang sama.' },
      { type: 'ubah', text: 'Personel yang belum disampling bulan ini ditulis "Belum disampling <bulan>", bukan "0 dari 0 journey sampling".' },
    ],
  },
  {
    version: '5.13.0',
    date: '2026-10-01',
    title: 'People Improvement per bulan: final & tindakan lanjutan',
    items: [
      { type: 'baru', text: 'Bulan yang sudah lewat ditutup otomatis tiap tanggal 1: nilai People Improvement-nya final dan tidak berubah lagi oleh sampling sesudahnya (tanda "Final").' },
      { type: 'baru', text: 'Tindakan bulan lalu yang belum terbukti improve otomatis masuk bulan berjalan sebagai tindakan lanjutan, dengan bobot yang sama. Bila improve lewat sampling terbaru, nilainya menambah bulan berjalan.' },
      { type: 'ubah', text: 'Kartu Total Tindakan memisahkan tindakan baru dan lanjutan; personel diberi badge jumlah tindakan lanjutan. Export memuat kolom yang sama.' },
    ],
  },
  {
    version: '5.12.0',
    date: '2026-10-01',
    title: 'Komplain valid memberatkan prioritas improvement',
    items: [
      { type: 'ubah', text: 'Personel Prioritas Improvement: personel yang terkait komplain valid bulan ini (tervalidasi/selesai dan terkait Pitcar) ditaruh paling atas, dari bobot terberat (Critical 5, Major 3, Minor 1), dan langsung direkomendasikan training. Sisanya tetap dari tingkat keberhasilan SOP terendah.' },
      { type: 'baru', text: 'Badge merah "Komplain" di nama personel; detail personel menampilkan daftar komplainnya. Export juga memuat kolom komplain dan bobotnya.' },
    ],
  },
  {
    version: '5.11.0',
    date: '2026-09-29',
    title: 'People Improvement tanpa istilah bobot',
    items: [
      { type: 'ubah', text: 'Kartu People Improvement menampilkan "x dari y tindakan terbukti improve". Nilainya tetap memberi porsi lebih besar untuk tindakan Critical & Major.' },
      { type: 'ubah', text: 'Ringkasan popup: Total Tindakan dan Tindakan Aktif menggantikan Total Bobot Gap dan Gap Aktif.' },
      { type: 'ubah', text: 'Kolom Bobot Aktif di tabel personel diganti PIC tindakan yang masih berjalan (juga di export).' },
      { type: 'perbaikan', text: 'Personel dari semua sampling yang temuannya digabung ke satu tindakan kini ikut tercantum di People Improvement.' },
    ],
  },
  {
    version: '5.10.0',
    date: '2026-09-29',
    title: 'Semua SOP tersampling di People Improvement',
    items: [
      { type: 'baru', text: 'Detail personel di People Improvement menampilkan semua SOP perannya yang disampling, lulus maupun gagal, lengkap dengan score rata-ratanya.' },
      { type: 'baru', text: 'Tiap checklist menunjukkan berapa kali sesuai dari berapa pemeriksaan: hijau selalu sesuai, kuning campuran, merah selalu tidak sesuai.' },
      { type: 'ubah', text: 'SOP yang pernah gagal langsung terbuka rinciannya; SOP yang lulus semua dilipat dan bisa dibuka.' },
    ],
  },
  {
    version: '5.9.0',
    date: '2026-09-27',
    title: 'FRT & ART masuk skor Lead Time, Lead Time Servis tanpa estimasi',
    items: [
      { type: 'ubah', text: 'First Response Time dan Average Response Time kini dinilai, masing-masing 3,75 poin. Target 5 menit: skor = 5 ÷ menit aktual × 100, maksimal 100 (sama dengan rumus KPI v3).' },
      { type: 'baru', text: 'Catatan perubahan: klik "Apa yang baru?" di atas nomor versi untuk melihat isi setiap rilis.' },
      { type: 'ubah', text: 'Lead Time Servis tetap tampil walau order belum punya estimasi durasi: rata-rata lama servis aktual dan jumlah ordernya, ditandai "belum dinilai".' },
      { type: 'ubah', text: 'Rata-rata lead time servis tidak lagi "belum terukur" bila jam mulai & selesai servis sudah tercatat.' },
    ],
  },
  {
    version: '5.8.0',
    date: '2026-09-26',
    title: 'Tingkat keberhasilan SOP',
    items: [
      { type: 'ubah', text: 'Kolom tingkat keberhasilan SOP menggantikan tingkat SOP gagal.' },
      { type: 'baru', text: 'Rekomendasi otomatis per personel: training, coaching, reminder, monitoring, atau sesuai standar.' },
      { type: 'ubah', text: 'Istilah kepatuhan diganti menjadi nilai/score agar lebih mudah dipahami.' },
    ],
  },
]
